// extracted by mini-css-extract-plugin
export default {"tooltip_content":"SettingsList_tooltip_content__vJdbN"};